import {
    ADD_KPI_KRA,
    CREATE_GOAL,
    CREATE_PROJECT,
    CREATE_PROJECT_TASK,
    DELETE_GOAL,
    DELETE_OBEJCTIVE,
    DELETE_PROJECT_LIST,
    DELETE_PROJECT_TASK_LIST,
    GET_GOAL,
    GET_GOAL_DETAILS,
    GET_OBEJCTIVE_DETAILS,
    GET_PROJECT_LIST,
    GET_PROJECT_TASK_LIST,
    FETCH_ERROR,
    FETCH_START,
    FETCH_SUCCESS,
    UPDATE_GOAL,
    UPDATE_KPI_KRA,
    UPDATE_PROJECT_LIST,
    UPDATE_PROJECT_TASK_LIST,
} from "shared/constants/ActionTypes";
const initialState = {
    projectList: [],
    projectTaskList: [],
    goalList: [],
    goalDetailList: {},
    objectiveDetailList: {},
    loading: false,
    error: null,
};
const objectiveDetailListHandlers = (oldState, payload) => {
    let newState = { ...oldState };
    return {
        ...newState,
        objective: {
            ...newState.objective,
            kraList: [
                ...newState.objective.kraList.map((item) => {
                    if (item.id == payload.id) {
                        return { ...payload };
                    } else {
                        return item;
                    }
                }),
            ],
        },
    };
};
const addKraKpiHandlers = (oldState, payload) => {
    let newState = { ...oldState };
    return {
        ...newState,
        objective: {
            ...newState.objective,
            kraList: [{ ...payload }],
        },
    };
};
export const performanceReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_START:
            return { ...state, loading: true };
        case FETCH_SUCCESS:
            return { ...state, loading: false };
        case FETCH_ERROR:
            return { ...state, error: action.payload, loading: false };
        case GET_PROJECT_LIST:
            return {
                ...state,
                projectList: action.payload,
            };
        case CREATE_PROJECT:
            return {
                ...state,
                projectList: [action.payload, ...state.projectList],
            };
        case UPDATE_PROJECT_LIST:
            return {
                ...state,
                projectList: [
                    ...state.projectList.map((item) =>
                        item.id === action.payload.id
                            ? { ...action.payload.data }
                            : item
                    ),
                ],
            };
        case DELETE_PROJECT_LIST:
            return {
                ...state,
                projectList: state.projectList.filter(
                    (el) => el.id !== action.payload.id
                ),
            };
        case GET_PROJECT_TASK_LIST:
            return {
                ...state,
                projectTaskList: action.payload,
            };
        case CREATE_PROJECT_TASK:
            return {
                ...state,
                projectTaskList: [action.payload, ...state.projectTaskList],
            };
        case UPDATE_PROJECT_TASK_LIST:
            return {
                ...state,
                projectTaskList: [
                    ...state.projectTaskList.map((item) =>
                        item.id === action.payload.id
                            ? { ...action.payload.data }
                            : item
                    ),
                ],
            };
        case DELETE_PROJECT_TASK_LIST:
            return {
                ...state,
                projectTaskList: state.projectTaskList.filter(
                    (el) => el.id !== action.payload.id
                ),
            };
        // GOAL
        case GET_GOAL:
            return {
                ...state,
                goalList: action.payload,
            };
        case CREATE_GOAL:
            return {
                ...state,
                goalList: [action.payload, ...state.goalList],
            };
        case UPDATE_GOAL:
            return {
                ...state,
                goalList: state.goalList.map((item) =>
                    item.id == action.payload.id ? action.payload : item
                ),
            };
        case DELETE_GOAL:
            return {
                ...state,
                goalList: state.goalList.filter(
                    (item) => item.id != action.payload.id
                ),
            };
        case GET_GOAL_DETAILS:
            return {
                ...state,
                goalDetailList: action.payload,
            };
        case GET_OBEJCTIVE_DETAILS:
            return {
                ...state,
                objectiveDetailList: action.payload,
            };
        case DELETE_OBEJCTIVE:
            return {
                ...state,
                goalDetailList: {
                    ...state.goalDetailList,
                    objectiveList: state.goalDetailList.objectiveList?.filter(
                        (item) => item.id != action.payload.id
                    ),
                },
            };
        case ADD_KPI_KRA:
            return {
                ...state,
                objectiveDetailList: addKraKpiHandlers(
                    state.objectiveDetailList,
                    action.payload
                ),
            };
        case UPDATE_KPI_KRA:
            return {
                ...state,
                objectiveDetailList: objectiveDetailListHandlers(
                    state.objectiveDetailList,
                    action.payload
                ),
            };
        default:
            return state;
    }
};
